import SlimSelect from "slim-select";

export default class SelectController {
    constructor() {
        this.init();
    }

    init() {
        this.selectBoxes = document.querySelectorAll("select");

        if (this.selectBoxes.length === 0) {
            return;
        }

        Array.from(this.selectBoxes).forEach((selectBox) => {
            new SlimSelect({
                select: selectBox,
                showSearch: false,
            });
        });
    }
}
